import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Table, TableLazyLoadEvent } from "primeng/table";
import { AssigmentModel } from "../../../schemas/assigment.model";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { AssignmentDialogComponent } from "../assignment-dialog/assignment-dialog.component";
import { ConfirmationService, LazyLoadEvent, MenuItem, MessageService } from "primeng/api";
import { AssigmentService } from "../../../services/assigment.service";
import { SharedAssigmentService } from "../../../services/sharedAssigment.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { SearchDialogComponent } from "../search-dialog/search-dialog.component";
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { debounceTime, takeUntil, distinctUntilChanged } from 'rxjs/operators';
import { LanguageService } from 'src/app/shared/language/language.service';
import { EncodeDecode } from 'src/app/shared/encode-decode/EncodeDecode';
import { AuthTokenService } from 'src/app/services/auth-token.service';

@Component({
    selector: 'app-table-customer',
    templateUrl: './table-customer.component.html',
    styleUrls: ['./table-customer.component.scss'],
    providers: [DialogService, ConfirmationService, MessageService],
    standalone: false
})
export class TableCustomerComponent implements OnInit {

    private sortState$ = new BehaviorSubject<{field: string, order: number}>({field: '', order: 1});
    private destroy$ = new Subject<void>();
    assigmentModels: AssigmentModel[] = [];
    items!: MenuItem[];
    loading: boolean = false;
    statuses: any[] = [];
    totalRecords = 0;
    activeAdvanceSearch = false;
    searchFormGroup: FormGroup = new FormGroup({});
    first: number = 0;
    
    language: string = 'IN';
    mailEncript !: string;
    user!: string;
    
    // Nuevas propiedades para la ordenación
    sortField: string = '';
    sortOrder: string = 'ASC';

    pageSize : number = 10;
    pageIndex : number = 0;

    constructor(
        private fb: FormBuilder,
        public dialogService: DialogService,
        private assigmentService: AssigmentService,
        private messageService: MessageService,
        private sharedAssignmentService: SharedAssigmentService,
        private confirmationService: ConfirmationService,
        private translate: TranslateService,
        private route: ActivatedRoute,
        private cdr: ChangeDetectorRef,
        private __languageService: LanguageService,
        private __router: Router,
        private __authService: AuthTokenService
    ) {
        this.initializeTranslations();
        this.initSearchForm();
    }

    initializeTranslations() {
        this.translate.setDefaultLang('en');
        this.route.params.subscribe(params => {
            const lang = params['language'] || 'en';
            this.setLanguage(lang);
        });
    }

    setLanguage(lang: string) {
        const normalizedLang = this.normalizeLanguage(lang);
        this.translate.use(this.isSupportedLanguage(normalizedLang) ? normalizedLang : 'en');
    }

    normalizeLanguage(lang: string): string {
        const uppercaseLang = lang.toLowerCase();
        return uppercaseLang === 'IN' ? 'EN' : uppercaseLang;
    }

    isSupportedLanguage(lang: string): boolean {
        const supportedLanguages = ['EN', 'ES', 'PT'];
        return supportedLanguages.includes(lang);
    }

    ref!: DynamicDialogRef;

    ngOnInit(): void {
        this.language = this.route.snapshot.paramMap.get('language')!;
        this.__languageService.setLanguage(this.language);
        this.mailEncript = this.route.snapshot.paramMap.get('email')!;
        try {
            let mail = EncodeDecode.b64DecodeUnicode(this.mailEncript);

            this.__authService.validateAccessUser(mail, 'SOM').subscribe((data: any) => {
                if (data.ac_result != 1) {
                    localStorage.clear();
                    sessionStorage.clear();
                    this.__router.navigate(['/noauthorized']);
                } else {
                    this.user = data.ac_usuario;
                    // this.loadLastAssignments();
                }
            });
        } catch (e) {
            console.log(e);
            localStorage.clear();
            sessionStorage.clear();
            this.__router.navigate(['/noauthorized']);
        }
    }

    initSearchForm(): void {
        this.searchFormGroup = this.fb.group({
            id: ['', Validators.required],
            customerId: ['', Validators.required],
            customerName: [''],
            areaId: ['', Validators.required],
            areaDescription: [''],
            isTeamService: [null],
            responsibleId: ['', [Validators.required]],
            responsibleName: ['']
        });
    }


    private createLazyLoadEvent(): LazyLoadEvent {
        debugger
        return {
            first: this.first,
            rows: this.pageSize,
            sortField: this.sortField,
            sortOrder: this.sortOrder == 'ASC' ? 1 : -1
        };
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private sortFieldMap: { [key: string]: string } = {
        'customerName': 'CUSTOMER_NAME',
        'areaDescription': 'TEAM_NAME',
        'responsibleName': 'RESPONSIBLE_NAME',
        'status': 'STATUS'
    };

 
    onSort(event: any) {
        const backendSortField = this.sortFieldMap[event.field] || event.field;
        this.sortState$.next({ 
            field: backendSortField, 
            order: event.order
        });
        // Removemos la llamada directa a loadAssigmentData aquí
    }

    onPageChange(event: any) {
        this.first = event.first;
        this.pageSize = event.rows;
        
        console.log(`Page changed: first=${this.first}, rows=${this.pageSize}`);
    
        this.loadAssigmentData(this.createLazyLoadEvent());
    }

    loadAssigmentData(event: TableLazyLoadEvent): void {
        debugger
        this.loading = true;
        
        this.pageSize = event.rows || this.pageSize;
        this.pageIndex = event.first != null ? Math.floor(event.first / this.pageSize) : this.pageIndex | 0;
        let sortField = '';
        if (event.sortField) {
            sortField = this.sortFieldMap[event.sortField as string] || event.sortField as string;
            this.sortField = sortField;
        }
        const sortOrder = event.sortOrder === 1 ? 'ASC' : 'DESC';
        this.sortOrder = sortOrder;

        console.log(`Loading data: pageSize=${this.pageSize}, pageIndex=${this.pageIndex}, sortField=${sortField}, sortOrder=${sortOrder}`);

        this.assigmentService.getAssignmentsPaginator(
            this.pageSize,
            this.pageIndex,
            sortField,
            sortOrder
        ).pipe(takeUntil(this.destroy$)).subscribe({
            next: (data) => {
                this.assigmentModels = data.data;
                this.totalRecords = data.totalRecords;
                this.loading = false;
                this.cdr.detectChanges();
            },
            error: (err) => {
                console.error('Error loading assignments:', err);
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to load assignments. Please try again.'
                });
                this.loading = false;
                this.cdr.detectChanges();
            }
        });
    }
   
    clear(table: Table) {
        table.clear();
    }

    showModalDialog() {
        const ref = this.dialogService.open(AssignmentDialogComponent, {
            header: this.translate.instant('assignmentDialog.title.new'),
            width: '70%',
            position: 'top',
            styleClass: 'custom-dialog-position',
            closable: true
        })!;
    
        ref.onClose.subscribe({
            next: (response) => {
                if (response) {
                    if (response.result === -1) {
                        this.messageService.add({
                            severity: 'error',
                            summary: this.translate.instant('general.error'),
                            detail: response.message 
                        });
                    } else {
                        this.assigmentModels.push(response.data); 
                        this.messageService.add({
                            severity: 'success',
                            summary: this.translate.instant('general.saved'),
                            detail: response.message 
                        });
                        this.loadAssigmentData(this.createLazyLoadEvent());
                    }
                }
            }
        });
    }
    
    showDetailAssignment(assignment: AssigmentModel) {
        const updatedAssignment = {
            ...assignment,
            customerName: assignment.customerName || ''
        };
    
        console.log("Opening modal with assignment:", updatedAssignment);
    
        this.ref = this.dialogService.open(AssignmentDialogComponent, {
            data: updatedAssignment,
            header: this.translate.instant('assignmentDialog.title.update'),
            width: '70%',
            position: 'top',
            styleClass: 'custom-dialog-position'
        })!;
    
        this.ref.onClose.subscribe({
            next: (response) => {
                if (response) {
                    if (response.result === -1) {
                        this.messageService.add({
                            severity: 'error',
                            summary: this.translate.instant('general.error'),
                            detail: response.message
                        });
                    } else {
                        this.messageService.add({
                            severity: 'success',
                            summary: this.translate.instant('general.updated'),
                            detail: response.message
                        });
                        this.loadAssigmentData(this.createLazyLoadEvent());
                    }
                } else {
                    console.log("Response is undefined, modal closed without data");
                }
            },
            error: (err) => {
                console.error("Error in modal response subscription:", err);
            }
        });
    }

    deleteAssignment(assignment: AssigmentModel) {
      
        
        this.translate.get([
            'confirmDialog.header',
            'confirmDialog.message',
            'messages.success.deleted',
            'messages.error.delete',
            'general.deleted',
            'general.error',
            'confirmDialog.acceptLabel',  
            'confirmDialog.rejectLabel'
        ]).subscribe(translations => {
            this.confirmationService.confirm({
                header: translations['confirmDialog.header'],
                message: translations['confirmDialog.message'],
                acceptLabel: translations['confirmDialog.acceptLabel'],  
                rejectLabel: translations['confirmDialog.rejectLabel'],
         
                accept: () => {
                    const assignmentId = assignment.id;
                    if (assignmentId) {
                        this.assigmentService.deleteAssignment(assignmentId, this.user).subscribe({
                            next: (response) => {
                                this.assigmentModels = this.assigmentModels.filter(a => a.id != assignmentId);
                                this.messageService.add({
                                    severity: 'success',
                                    summary: translations['general.deleted'],
                                    detail: translations['messages.success.deleted']
                                });
                            },
                            error: (err) => {
                                this.messageService.add({
                                    severity: 'error',
                                    summary: translations['general.error'],
                                    detail: translations['messages.error.delete']
                                });
                                console.error(err);
                            }
                        });
                    }
                }
            });
        });
    }

    showAdvanceSearch(active = true) {
        this.activeAdvanceSearch = active;
    }

    searchTeam() {
        this.translate.get('search.team').subscribe((res: string) => {
            this.showSearchDialog(null, res, 'TEAM');
        });
    }

    searchResponsible() {
        this.translate.get('search.responsible').subscribe((res: string) => {
            this.showSearchDialog(this.searchFormGroup.get('areaId')?.value, res, 'RESPONSIBLE');
        });
    }

    searchCustomer() {
        this.translate.get('search.customer').subscribe((res: string) => {
            this.showSearchDialog(null, res, 'CUSTOMER');
        });
    }

    searchAssignments() {
        debugger
        console.log(this.searchFormGroup.getRawValue())

        this.assigmentService.getAssignmentsPaginator(this.pageSize,
            this.pageIndex,
            this.sortField,
            this.sortOrder,
            this.searchFormGroup.get('customerId')?.value,
            this.searchFormGroup.get('areaId')?.value,
            this.searchFormGroup.get('responsibleId')?.value
        ).subscribe({
            next: (data) => {
                this.assigmentModels = data.data;
                this.totalRecords = data.totalRecords; 
                this.activeAdvanceSearch = false;
            }, error: (err) => {
                console.error(err)
            }
        })
    }

    showSearchDialog(data: any, header: string, collection: string) {
        console.log(collection);
        const searchDialogRef = this.dialogService.open(SearchDialogComponent, {
            data: data,
            width: '60%',
            header: header,
            position: 'top',
            styleClass: 'custom-dialog-position'
        })!;
        
        searchDialogRef.onClose.subscribe({
            next: (data) => {
                if (data) {
                    switch (collection) {
                        case 'TEAM':
                            this.searchFormGroup.patchValue({
                                areaId: data.id,
                                areaDescription: data.description
                            });
                            break;
                        case 'CUSTOMER':
                            this.searchFormGroup.patchValue({
                                customerId: data.id,
                                customerName: data.name
                            });
                            break;
                        case 'RESPONSIBLE':
                            this.searchFormGroup.patchValue({
                                responsibleId: data.user,
                                responsibleName: data.name
                            });
                            break;
                    }
                    console.log(this.searchFormGroup.value);
                }
            },
            error: (err) => {
                this.translate.get('error.generic').subscribe((res: string) => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: res
                    });
                });
                console.error(err);
            }
        });
    }



    clearForm() {
        this.searchFormGroup.reset();
    }
}